// MissionTemplateOrder.js

const MISSION_TEMPLATE_ORDER_STEP = 100;

export function getMissionTemplateIdentity(template) {
  return String(template?.key || '').trim() || null;
}

export function normalizeMissionTemplatePosition(value) {
  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : null;
}

function getMissionTemplateLabel(template) {
  return String(template?.title || '').trim();
}

export function compareMissionTemplatesByConfiguredOrder(left, right) {
  const positionLeft = normalizeMissionTemplatePosition(left?.position);
  const positionRight = normalizeMissionTemplatePosition(right?.position);

  if (positionLeft != null && positionRight != null && positionLeft !== positionRight) {
    return positionLeft - positionRight;
  }

  if (positionLeft != null && positionRight == null) return -1;
  if (positionLeft == null && positionRight != null) return 1;

  const labelCompare = getMissionTemplateLabel(left).localeCompare(getMissionTemplateLabel(right), undefined, {
    sensitivity: 'base',
  });
  if (labelCompare !== 0) return labelCompare;

  return String(getMissionTemplateIdentity(left) || '').localeCompare(String(getMissionTemplateIdentity(right) || ''), undefined, {
    sensitivity: 'base',
  });
}

export function sortMissionTemplatesByConfiguredOrder(templates) {
  return [...(Array.isArray(templates) ? templates : [])].sort(compareMissionTemplatesByConfiguredOrder);
}

export function moveOrderedMissionTemplateByKey(templates, fromKey, toKey) {
  const currentTemplates = Array.isArray(templates) ? templates : [];
  const normalizedFromKey = String(fromKey || '').trim();
  const normalizedToKey = String(toKey || '').trim();

  if (!normalizedFromKey || !normalizedToKey || normalizedFromKey === normalizedToKey) return null;

  const fromIndex = currentTemplates.findIndex((template) => getMissionTemplateIdentity(template) === normalizedFromKey);
  const toIndex = currentTemplates.findIndex((template) => getMissionTemplateIdentity(template) === normalizedToKey);

  if (fromIndex < 0 || toIndex < 0) return null;

  const nextTemplates = [...currentTemplates];
  const [movedTemplate] = nextTemplates.splice(fromIndex, 1);
  nextTemplates.splice(toIndex, 0, movedTemplate);
  return nextTemplates;
}

export function getNextMissionTemplatePosition(templates) {
  const orderedTemplates = sortMissionTemplatesByConfiguredOrder(templates);
  const positions = orderedTemplates
    .map((template) => normalizeMissionTemplatePosition(template?.position))
    .filter((position) => position != null);

  if (!positions.length) return 0;
  return Math.max(...positions) + MISSION_TEMPLATE_ORDER_STEP;
}
